import { IComponentOptions, IController } from 'angular';
import { GmcAccordionTabController } from './components/gmc-accordion-tab/gmc-accordion-tab.component';
import './gmc-accordion.component.scss';

export class GmcAccordionController implements IController {
  private tabs: GmcAccordionTabController[] = [];

  public addTab( tab: GmcAccordionTabController ) {
    this.tabs = [ ...this.tabs, tab ];
  }

  public toggleTab( targetTab: GmcAccordionTabController ) {
    this.tabs.forEach(( tab ) => {
      tab === targetTab ? tab.isActive = !tab.isActive : tab.isActive = false;
    });
  }

  public removeTab( tab: GmcAccordionTabController ) {
    const index = this.tabs.indexOf(tab);
    if ( index >= 0 ) {
      this.tabs = [
        ...this.tabs.slice(0, index),
        ...this.tabs.slice(index + 1)
      ];
    }
  }
}

export const GmcAccordionComponent: IComponentOptions = {
  controller: GmcAccordionController,
  template: require('./gmc-accordion.component.html'),
  transclude: true
};



// WEBPACK FOOTER //
// ./app/shared/components/gmc-accordion/gmc-accordion.component.ts